/* FRAICHEUR+ theme - comportements front (vanilla JS) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = window.routes || {};
  var strings = window.cartStrings || {};

  /* ---------- Toast ---------- */
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  function toast(msg) {
    var wrap = $('#ToastWrap') || (function () { var w = document.createElement('div'); w.className = 'toast-wrap'; w.id = 'ToastWrap'; document.body.appendChild(w); return w; })();
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<span class="ic">' + CHECK + '</span><span>' + msg + '</span>';
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 400); }, 2600);
  }

  /* ---------- Scroll reveal ---------- */
  var revealObserver;
  function observeReveals(root) {
    if (!('IntersectionObserver' in window)) { $$('.reveal', root).forEach(function (el) { el.classList.add('in'); }); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealObserver.unobserve(e.target); } });
      }, { threshold: 0.12 });
    }
    $$('.reveal:not(.in)', root || document).forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Compteurs animes ---------- */
  function initCounters() {
    var els = $$('[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = parseFloat(el.getAttribute('data-count')) || 0;
        var suffix = el.getAttribute('data-suffix') || '', t0 = null, dur = 1100;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min((ts - t0) / dur, 1);
          el.textContent = Math.round(end * (0.5 - Math.cos(Math.PI * k) / 2)) + suffix;
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Accordeons ---------- */
  function initAccordions(root) {
    $$('[data-accordion]', root || document).forEach(function (acc) {
      if (acc.dataset.bound) return; acc.dataset.bound = '1';
      $$('.acc-q', acc).forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.acc-item');
          var a = item.querySelector('.acc-a');
          var open = item.classList.toggle('open');
          a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
        });
      });
    });
  }

  /* ---------- Menu mobile ---------- */
  function initMenu() {
    var toggle = $('.menu-toggle'), links = $('.nav-links');
    if (toggle && links) toggle.addEventListener('click', function () { links.classList.toggle('open'); toggle.classList.toggle('active'); });
  }

  /* ---------- Cart drawer ouverture / fermeture ---------- */
  function openDrawer() { var d = $('#CartDrawer'); if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); } }
  function closeDrawer() { var d = $('#CartDrawer'); if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); } }
  function initDrawer() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Mise a jour du panier (compteur, drawer) ---------- */
  function refreshCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('show', cart.item_count > 0);
    });
    var total = $('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
    var foot = $('[data-cart-foot]'); if (foot) foot.hidden = cart.item_count === 0;
    renderDrawerItems(cart);
  }

  function renderDrawerItems(cart) {
    var items = $('[data-cart-items]'); if (!items) return;
    if (!cart.items || !cart.items.length) {
      items.innerHTML = '<div class="cd-empty"><p>' + (strings.empty || 'Votre panier est vide.') + '</p></div>';
      return;
    }
    items.innerHTML = cart.items.map(function (it, i) {
      var img = it.image
        ? '<img src="' + it.image + '&width=128" alt="' + esc(it.title) + '" width="64" height="64">'
        : '<div class="cd-art"></div>';
      var meta = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<div class="cd-meta">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cd-line" data-cart-line="' + (i + 1) + '" data-key="' + it.key + '">' +
        img +
        '<div><div class="cd-name">' + esc(it.product_title) + '</div>' + meta +
        '<div class="cd-meta">' + it.quantity + ' &times; ' + formatMoney(it.final_price) + '</div>' +
        '<button class="cd-remove" type="button" data-cart-remove="' + it.key + '">' + (strings.remove || 'Retirer') + '</button></div>' +
        '<div style="font-weight:800;color:var(--ink)">' + formatMoney(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return v + ' €';
  }

  /* ---------- Ajout au panier en AJAX ---------- */
  function initAjaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('loading'); }
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(serialize(form))
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || strings.error || 'Erreur'); return; }
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            refreshCartUI(cart);
            toast(strings.added || 'Ajoute au panier');
            openDrawer();
          });
        })
        .catch(function () { toast(strings.error || 'Erreur'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('loading'); } });
    });
  }

  function serialize(form) {
    var data = { quantity: 1 };
    $$('[name]', form).forEach(function (f) {
      if (f.name === 'id') data.id = f.value;
      else if (f.name === 'quantity') data.quantity = parseInt(f.value, 10) || 1;
    });
    return data;
  }

  /* ---------- Page panier : quantites + suppression ---------- */
  function changeLine(key, qty) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); })
      .catch(function () { toast(strings.error || 'Erreur'); });
  }
  function initCartPage() {
    var page = $('[data-cart-page]'); if (!page) return;
    page.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-row]'); if (!row) return;
      var input = row.querySelector('[data-cart-qty]');
      var key = row.getAttribute('data-key');
      if (e.target.closest('[data-cart-plus]')) changeLine(key, (parseInt(input.value, 10) || 1) + 1);
      else if (e.target.closest('[data-cart-minus]')) changeLine(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1));
      else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });
    $$('[data-cart-qty]', page).forEach(function (inp) {
      inp.addEventListener('change', function () { changeLine(inp.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0)); });
    });
  }

  /* drawer remove */
  function initDrawerRemove() {
    var items = $('[data-cart-items]'); if (!items) return;
    items.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]'); if (!btn) return;
      var key = btn.getAttribute('data-cart-remove');
      fetch(routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) { refreshCartUI(cart); }).catch(function () {});
    });
  }

  /* ---------- Filtres : auto-submit + tri + toggle mobile ---------- */
  function initFacets() {
    var form = $('[data-facet-form]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    var toggle = $('[data-filter-toggle]'), panel = $('[data-filter-panel]') || $('.filters-panel');
    if (toggle && panel) toggle.addEventListener('click', function () { panel.classList.toggle('open'); });
  }

  /* ---------- Assistant 3 questions ---------- */
  function initAssistant() {
    var root = $('[data-assistant]'); if (!root) return;
    var steps = $$('.assistant-step', root);
    var progress = $$('[data-progress] span', root);
    var counter = $('[data-counter]', root);
    var back = $('[data-back]', root);
    var current = 0;

    function show(i) {
      steps.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      progress.forEach(function (p, k) { p.classList.toggle('on', k <= i); });
      if (counter) counter.textContent = 'Question ' + (i + 1) + ' sur ' + steps.length;
      if (back) back.hidden = i === 0;
      current = i;
    }
    root.addEventListener('click', function (e) {
      var nx = e.target.closest('[data-next]');
      var fn = e.target.closest('[data-finish]');
      if (nx) { if (current < steps.length - 1) show(current + 1); }
      else if (e.target.closest('[data-back]')) { if (current > 0) show(current - 1); }
      else if (fn) {
        var base = root.getAttribute('data-base-url');
        var typeKey = root.getAttribute('data-type-key');
        var sortKey = root.getAttribute('data-sort-key');
        var type = fn.getAttribute('data-type');
        var sort = fn.getAttribute('data-sort');
        var url = new URL(base, window.location.origin);
        if (type) url.searchParams.set(typeKey, type);
        if (sort) url.searchParams.set(sortKey, sort);
        window.location.href = url.toString();
      }
    });
    show(0);
  }

  /* ---------- Comparateur (selection persistee localStorage) ---------- */
  var Compare = {
    key: 'fraicheur_compare', max: 4,
    get: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    save: function (l) { localStorage.setItem(this.key, JSON.stringify(l)); },
    toggle: function (h) {
      var l = this.get(), i = l.indexOf(h);
      if (i > -1) l.splice(i, 1);
      else { if (l.length >= this.max) { toast('Comparaison limitee a ' + this.max + ' produits'); return false; } l.push(h); }
      this.save(l); return true;
    }
  };
  function syncCompareButtons() {
    var l = Compare.get();
    $$('[data-compare]').forEach(function (b) { b.classList.toggle('active', l.indexOf(b.getAttribute('data-compare')) > -1); });
    $$('[data-compare-count]').forEach(function (el) { el.textContent = l.length; });
  }
  function initCompare() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-compare]'); if (!b) return;
      e.preventDefault();
      if (Compare.toggle(b.getAttribute('data-compare'))) syncCompareButtons();
    });
    syncCompareButtons();
    window.Compare = Compare;
  }

  /* ---------- Page produit : quantite, variantes, galerie, sticky ---------- */
  function initProduct() {
    var form = $('[data-product-form]'); if (!form) return;
    var qty = $('#qtyVal', form);
    if (qty) {
      var inc = form.querySelector('[data-q="inc"]'), dec = form.querySelector('[data-q="dec"]');
      if (inc) inc.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    }
    var stage = $('[data-pd-stage]');
    $$('[data-pd-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        $$('[data-pd-thumb]').forEach(function (x) { x.classList.remove('active'); });
        th.classList.add('active');
        var src = th.getAttribute('data-media');
        if (stage && src) stage.innerHTML = '<img src="' + src + '" alt="" class="pd-img">';
      });
    });
    var sticky = $('[data-sticky-buy]'), buyBox = $('.pd-buy');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(buyBox);
    }
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    observeReveals();
    initCounters();
    initAccordions();
    initMenu();
    initDrawer();
    initDrawerRemove();
    initAjaxAdd();
    initCartPage();
    initFacets();
    initAssistant();
    initCompare();
    initProduct();
  });
})();
